import { ModifyLineItemProperties } from './ModifyLineItemProperties';
/**
 * A list of Audio line item properties that are allowed to be modified
 */
export class ModifyAudioLineItemProperties extends ModifyLineItemProperties {
}
